/**
 * Created by sswaminathan on 1/8/22
 * File: LicenseProductInfo
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

/**
 *   TODO: Brief what is this component/class do
 */
import { useCallback, useContext } from 'react'
import styled from 'styled-components'
import { APP_ID_TO_NAME } from '../../../common/constants/LabelConstants'
import { FF_SHOW_ALLOCATION } from '../../../common/utils/FeatureFlags'
import { getVarValue } from '../../../common/utils/Sparky'
import LicenseCardHeader from '../LicenseCard/LicenseCardHeader'
import SubscriptionAllocation from '../subscriptionAllocation/SubscriptionAllocation'
import AppContext from '../../../common/context/AppContext'


export const VerticalLine = styled.div`
    border-right: 1px solid #000000;
    height: 100px;
    opacity: 0.3;
    }`
const LicenseProductInfo = ({ isCgx, item, licenseValue, allocation, handleAllocationOnChange, ...rest }) => {
  const showAllocation = getVarValue(FF_SHOW_ALLOCATION, false)
  const { getAppName } = useContext(AppContext)
  const getAddonName = useCallback(() => {
    const addOnName = []
    item.licenseCardInfo.addOns && item.licenseCardInfo.addOns.forEach(each => addOnName.push({ ui_display_name: getAppName(each, APP_ID_TO_NAME[each]) }))
    return addOnName
  }, [getAppName, item.licenseCardInfo.addOns])

  return (<div className='tw-flex tw-flex-row tw-pl-4'>
    {showAllocation && item.allocation && <SubscriptionAllocation
      defaultAllocation={allocation}
      changeHandler={handleAllocationOnChange} {...{ item, licenseValue, rest }}/>
    }
    {!isCgx && showAllocation &&
    <div className='tw-w-48 tw-flex-none'>
      <VerticalLine/>
    </div>
    }
    <div className={isCgx || !showAllocation ? '' : 'tw-ml-8'}>
      <LicenseCardHeader
        label={getAppName(item.licenseCardInfo.licenseDisplayName)}
        quantity={item.licenseCardInfo.licenseQuantity}
        location ={item.licenseCardInfo.serviceLocation}
        expiry ={item.licenseCardInfo.expiry}
        addons={getAddonName()}
        showAddOns={true}
        isPanChina={item.licenseCardInfo.isPanChina}
        showImage={!isCgx}
        imageName={item.licenseCardInfo.licenseDisplayName}/>
    </div>
  </div>)
}

LicenseProductInfo.propTypes = {}
export default LicenseProductInfo
